module.exports = __webpack_public_path__ + "img/BGIR_Logo.2fa05ed9.webp";